import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/installments/:installmentId/settle`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const settle = {
  post: apiPathFunc(pathBase),
};
